module.exports = __webpack_public_path__ + "static/media/IMG_1638.b6063ca3.jpg";